import styles from "./Avatar.module.css";

export function Avatar({
	firstName,
	lastName,
	email,
	size = 36,
}: {
	firstName?: string | null | undefined;
	lastName?: string | null | undefined;
	email?: string | null | undefined;
	size?: number | undefined;
}) {
	const initials = `${firstName?.[0] ?? ""}${lastName?.[0] ?? ""}`.toUpperCase();
	const label = initials || email?.[0]?.toUpperCase() || "?";

	return (
		<div
			className={styles.avatar}
			style={{ width: size, height: size, fontSize: size * 0.4 }}
			title={[firstName, lastName].filter(Boolean).join(" ") || email || undefined}
		>
			{label}
		</div>
	);
}
